import React from 'react';
import { TrendingUp, HelpCircle } from 'lucide-react';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: React.ElementType;
  trend?: string;
  trendUp?: boolean;
  tooltip?: string;
}

export const StatCard: React.FC<StatCardProps> = ({ title, value, icon: Icon, trend, trendUp, tooltip }) => {
  return (
    <div className="premium-card p-6 group relative">
      <div className="flex justify-between items-start mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-indigo-500/10 flex items-center justify-center border border-indigo-500/20 group-hover:bg-indigo-500/20 transition-colors duration-300">
            <Icon className="w-5 h-5 text-indigo-400" />
          </div>
          {tooltip && (
            <div className="group/tooltip relative">
              <HelpCircle className="w-3 h-3 text-slate-700 cursor-help hover:text-indigo-400 transition-colors" />
              <div className="absolute bottom-full left-0 mb-2 w-48 p-2 bg-slate-900 border border-white/10 rounded-lg text-[10px] text-slate-400 opacity-0 invisible group-hover/tooltip:opacity-100 group-hover/tooltip:visible transition-all z-50 shadow-2xl font-normal normal-case tracking-normal">
                {tooltip}
              </div>
            </div>
          )}
        </div>
        {trend && (
          <div className={`flex items-center gap-1 px-2 py-1 rounded-lg text-[10px] font-bold ${
            trendUp ? 'bg-emerald-500/10 text-emerald-400' : 'bg-rose-500/10 text-rose-400'
          }`}>
            {trendUp ? <TrendingUp className="w-3 h-3" /> : <TrendingUp className="w-3 h-3 rotate-180" />}
            {trend}
          </div>
        )}
      </div>
      <div className="space-y-1">
        <p className="micro-label">{title}</p>
        <div className="flex items-baseline gap-2">
          <h3 className="text-2xl font-bold text-white tracking-tight">{value}</h3>
          <span className="text-[10px] text-slate-500 font-medium">vs mês anterior</span>
        </div>
      </div>
    </div>
  );
};